import { Alert } from "reactstrap";
import {
  faCopy,
  faInfoCircle,
  faWarning,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ContactFormLink } from "../help/ContactFormLink";
import joinCrewHelp from "../crew/joinCrewHelp.webp";
import Zoom from "react-medium-image-zoom";
import { useCrewsQuery } from "./useCrewsQuery";
import { Trans, useTranslation } from "react-i18next";

export function NoCrewMembershipFoundAlert() {
  const { t } = useTranslation();

  const { crews } = useCrewsQuery();

  return crews !== undefined && crews.length === 0 ? (
    <Alert color="warning" className="mt-2" fade={false}>
      <h4>
        <FontAwesomeIcon icon={faWarning} /> {t("crew.noMembership.title")}
      </h4>
      <p>{t("crew.noMembership.desc")}</p>

      <h5>{t("crew.noMembership.whatToDoTitle")}</h5>
      <p>{t("crew.noMembership.whatToDoDesc")}</p>
      <ol>
        {t("crew.noMembership.steps", { returnObjects: true }).map(
          (step, i) => (
            <li key={i}>
              <Trans
                components={{
                  iconUsers: (
                    <FontAwesomeIcon icon={faUsers} className="pe-1" />
                  ),
                  iconCopy: <FontAwesomeIcon icon={faCopy} className="pe-1" />,
                  iconInfo: (
                    <FontAwesomeIcon icon={faInfoCircle} className="pe-1" />
                  ),
                }}
              >
                {step}
              </Trans>
            </li>
          ),
        )}
      </ol>
      <Zoom>
        {" "}
        <img src={joinCrewHelp} className="img-thumbnail" width="300px" />
      </Zoom>
      <p></p>
      <h5>{t("help.support.title")}</h5>
      <p>
        <Trans
          i18nKey="crew.noMembership.additionalSupport"
          components={{
            contactFormLink: <ContactFormLink />,
          }}
        />
      </p>
    </Alert>
  ) : (
    <></>
  );
}
